<!-- Search Filter Category Item Component - Ellipsis and Tooltip functionalities for item name-->
<template>
  <div
    class="wc-search-filter-category-item"
    :class="addEllipsis(itemValue) && 'text-truncate'"
    :ref="itemValue"
  >
    {{ itemValue }}
    <WCToolTip
      v-if="addEllipsis(itemValue)"
      :target="itemValue"
      position="bottom"
      class="font-size-sm"
    >
      {{ itemValue }}
    </WCToolTip>
  </div>
</template>

<script>
import WCToolTip from '@/components/WCToolTip/WCToolTip.vue';
import { MAX_CHAR_LENGTH } from '@/constants/AppConstants';

export default {
  components: {
    WCToolTip,
  },
  props: {
    itemValue: {
      type: String,
      required: true,
    },
  },
  methods: {
    /**
     * Method that decides on adding ellipsis for single and multiple words.
     */
    addEllipsis(value) {
      const itemValueWords = value.split(' ');
      const longest = itemValueWords.sort(function(a, b) {
        return b.length - a.length;
      })[0];
      return this.charLengthCheck(longest);
    },
    /**
     * Method to check the length of characters in the string
     */
    charLengthCheck(categoryItem) {
      const itemValueLength = categoryItem.length;
      if (itemValueLength >= MAX_CHAR_LENGTH) return true;
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.wc-search-filter-category-item {
  cursor: pointer;
}
</style>
